import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'timezoneClean',
    standalone: false
})
export class TimezoneCleanPipe implements PipeTransform {
  transform(timezone: string): string {
    return timezone.replace('_', ' ');
  }

}
